import { hasViewableHistory } from '@user/utils/knockStatusFormatting'

export type ClearedKnockStatusHistory = {
  knockStatusLocationId: number
  count: number
} | null

export type KnockStatusHistorySource = {
  hasActiveStatus: boolean
  /** From the map tile — only populated while a status is active. */
  activeLocationId: number | null
  activeCount?: number | null
  /** From the coordinate lookup, for a location whose status was cleared. */
  cleared: ClearedKnockStatusHistory
}

export type KnockStatusHistoryLink = {
  locationId: number | null
  canView: boolean
}

// With an active status the tile carries both the location id and the history count. Once the
// status is cleared it carries neither, so fall back to what the coordinate lookup resolved
// (SH-1816). canView folds in the id check: there is nothing to open without one.
export function resolveKnockStatusHistoryLink({
  hasActiveStatus,
  activeLocationId,
  activeCount,
  cleared,
}: KnockStatusHistorySource): KnockStatusHistoryLink {
  const locationId = hasActiveStatus
    ? activeLocationId
    : (cleared?.knockStatusLocationId ?? null)
  const count = hasActiveStatus ? (activeCount ?? 0) : (cleared?.count ?? 0)

  return {
    locationId,
    canView: locationId !== null && hasViewableHistory(count, hasActiveStatus),
  }
}
